import create from './base'
import {stringify} from 'qs'
import {baseUrl} from '../config'

const http = create()
http.defaults.baseURL = baseUrl + '/api/infomechanism'


//查询评审机制列表
const queryMechanism = (schoolCode, taskId) => {
    return http.get('/v1/query_tree?' + stringify({
        schoolCode, taskId
    }))
}
// 保存评审机制
const saveMechanism = ( dataJson ) => {
    return http.post('/v1/save', stringify(dataJson))
}
// 修改评审机制
const updateMechanism = ( dataJson ) => {
    return http.post('/v1/update', stringify(dataJson))
}
//删除评审机制
const delMechanism = (id) => {
    return http.post('/v1/delete?' + stringify({
        id
    }))
}

//评审查询作品得分维度指标
const queryMechanismIndex = (schoolCode, taskId) => {
    return http.get('/v1/query_mechanism_index?' + stringify({
        schoolCode, taskId
    }))
}

// 以下为上海二次需求修改后用到的接口
// 查询二级维度和指标
const queryMechanismIndexTwoV2 = (data) => {
    return http.get('/v2/query_mechanism_index?' + stringify(data))
}
// 查询三级维度和指标
const queryMechanismIndexTwoV3 = (data) => {
    return http.get('/v3/query_mechanism_index?' + stringify(data))
}



export default {
    queryMechanism,
    saveMechanism,
    updateMechanism,
    delMechanism,
	queryMechanismIndex,
	queryMechanismIndexTwoV2,
	queryMechanismIndexTwoV3
}
